<q9-select
  [label]="'ASIDE_R.THEME_LABEL' | translate"
  [formControl]="theme"
  (selectionChange)="openThemePopUp($event.value)">
  <q9-option *ngFor="let theme of diagramThemes" [value]="theme">
    <ng-container *ngIf="theme.name | decodeHtml as themeName">
      {{ themeName }}
    </ng-container>
  </q9-option>
</q9-select>
